import Vue from "vue";
import { query } from "./plugins/apollo";

Vue.prototype.$query = query;
